import { render, staticRenderFns } from "./MyTree.vue?vue&type=template&id=5bef915b&scoped=true"
import script from "./MyTree.vue?vue&type=script&lang=js"
export * from "./MyTree.vue?vue&type=script&lang=js"
import style0 from "./MyTree.vue?vue&type=style&index=0&id=5bef915b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bef915b",
  null
  
)

export default component.exports